import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Dropdown } from 'semantic-ui-react';
import styles from './DropdownSearch.less';

class DropdownSearchField extends Component {
  static propTypes = {
    field: PropTypes.shape({}).isRequired,
    form: PropTypes.shape({}).isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({})),
  }

  static defaultProps = {
    placeholder: '',
    label: '',
    options: [{}],
  }

  handleChange = (event, { value }) => {
    const { field: { name }, form: { setFieldValue } } = this.props;
    setFieldValue(name, value);
  }

  handleBlur = (event, { value }) => {
    const { field: { name }, form: { setFieldValue, setFieldTouched } } = this.props;
    setFieldValue(name, value);
    setFieldTouched(name);
  }

  render() {
    const {
      placeholder,
      label,
      field: { name, value },
      form: { touched, errors },
      options,
    } = this.props;

    const val = value === -1 ? undefined : value;

    return (
      <Form.Field className={styles.field}>
        <div className={styles.label}>{label}</div>
        <Dropdown
          placeholder={placeholder}
          fluid
          selection
          options={options}
          value={val}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
        />
        {
          touched[name]
          && errors[name]
          && <div className={styles.error}>{errors[name]}</div>
        }
      </Form.Field>
    );
  }
}

export default DropdownSearchField;
